import { render, staticRenderFns } from "./Voicemails.vue?vue&type=template&id=251c3dfc&"
import script from "./Voicemails.vue?vue&type=script&lang=ts&"
export * from "./Voicemails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports